import { format, parseISO } from "date-fns";
import Popover from "./Popover";
import { Stack, Text, TextProps } from "@adfenix/alexandria";

type formatType = "date";

interface Props extends TextProps {
  timestamp?: string;
  dateFormat?: formatType;
}

export const Timestamp = ({ timestamp, dateFormat, ...props }: Props) => {
  if (!timestamp) return null;

  // Dependent on which version of entity framework the backend is using the dates can come with or without a Z in the end. But they should always be UTC so this adds a Z to the end if it isn't there
  if (!timestamp.endsWith("Z")) timestamp = timestamp + "Z";

  let formatString = "yyyy-MM-dd HH:mm:ss";

  if (dateFormat === "date") formatString = "yyyy-MM-dd";

  const date = new Date(timestamp);

  return (
    <Popover
      maxWidth={240}
      trigger={
        <Text {...props}>{format(parseISO(timestamp), formatString)}</Text>
      }
    >
      <Stack spacing="s">
        <p>{format(parseISO(timestamp), "yyyy-MM-dd HH:mm:ss")}</p>
        <p>Timezone: {format(parseISO(timestamp), "z")}</p>
        <p>
          UTC: {date.toISOString().substring(0, 10)}{" "}
          {date.toISOString().substring(11, 19)}
        </p>
      </Stack>
    </Popover>
  );
};
